var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxEdgeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 70,
    viewBox: "0 0 56 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.413 21.4599C33.1812 26.399 40.6739 43.0219 0.5 70V0H55.5C55.5 2.21411 49.2826 9.60584 24.413 21.4599Z",
    fill: "url(#paint0_linear_555_2191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_555_2191",
    x1: 44.453,
    y1: 20.6667,
    x2: -3.40066,
    y2: 47.5908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxEdgeVector);
export default __webpack_public_path__ + "static/media/box-edge-vector.41edae885f00d28b17ee99390317b122.svg";
export { ForwardRef as ReactComponent };